import { callBackend } from './backend';

export type { ApiResponse } from './backend';

export const authApi = {
  bootstrap: () => callBackend('auth', { action: 'bootstrap' }),
  adminLogin: (email: string, password: string) =>
    callBackend('auth', { action: 'adminLogin', email, password }),
  me: (token: string) => callBackend('auth', { action: 'me', token }),
  logout: (token: string) => callBackend('auth', { action: 'logout', token }),
};